import { NgModule } from '@angular/core';
import { BookingService } from './booking.service';
import { AirBookingService } from './airBooking.service';
import { HotelBookingService } from './hotelBooking.service';
import { SsrServiceModule } from '../ssrs/SsrsService.module';
import { VehicleRentalBookingService } from "./vehicleRentalBooking.service";

@NgModule({
    imports:[
        SsrServiceModule,
    ],
    providers: [
        BookingService,
        AirBookingService,
        HotelBookingService,
        VehicleRentalBookingService
    ],
})
export class BookingServiceModule {  }